import { DateTime } from 'luxon';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';
import Tarefa from 'Interface/Tarefas';
import { useAppSelector } from 'Store';

interface Props {
  tarefa: Tarefa;
}

const Informacoes = ({ tarefa }: Props): JSX.Element => {
  const usuarioId = useAppSelector((estado) => estado.autenticacao.usuario?.id);

  const usuario = useMemo(() => {
    if (usuarioId == tarefa.atendente_id) {
      return tarefa.proprietario;
    }

    return tarefa.atendente;
  }, [tarefa.atendente, tarefa.atendente_id, tarefa.proprietario, usuarioId]);

  return (
    <li className="list-group-item py-3 d-flex align-items-center gap-3 border-0 bg-transparent">
      <Imagem
        src={usuario?.imagem}
        alt={usuario?.nome}
        className="rounded-circle object-fit-cover border border-3 border-light shadow"
        width="80"
        height="80"
      />
      <div className="flex-grow-1 text-truncate">
        <strong className=" text-truncate">{usuario?.nome}</strong>
        <small className="d-block text-muted text-truncate">
          Em {tarefa.criado.data().toLocaleString(DateTime.DATETIME_SHORT)}
        </small>
        <small className="d-block text-body text-truncate">
          Prazo até{' '}
          {tarefa.prazo.data().toLocaleString(DateTime.DATETIME_SHORT)}
        </small>
      </div>
      <div className="d-flex justify-content-end align-items-center">
        <Link
          className="fs-1"
          to={`/admin/tarefas/editar/${tarefa.id}/observacoes`}
        >
          <Icone nome="chat-dots" />
        </Link>
      </div>
    </li>
  );
};

export default Informacoes;
